import api from './api';

const backupService = {
  async getInfo() {
    try {
      const response = await api.get('/backup/info');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener informacion de backups'
      };
    }
  },

  async create() {
    try {
      const response = await api.post('/backup/create');
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear backup'
      };
    }
  },

  async download(filename) {
    try {
      const response = await api.get(`/backup/download/${encodeURIComponent(filename)}`, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data]);
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al descargar backup'
      };
    }
  },

  async delete(filename) {
    try {
      const response = await api.delete(`/backup/delete/${encodeURIComponent(filename)}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar backup del servidor'
      };
    }
  },

  async createDownloadAndDelete() {
    const createResult = await this.create();
    if (!createResult.success) {
      return createResult;
    }

    const filename = createResult.data?.filename;
    if (!filename) {
      return {
        success: false,
        message: 'No se pudo obtener el nombre del backup generado'
      };
    }

    const downloadResult = await this.download(filename);
    if (!downloadResult.success) {
      return {
        success: false,
        message: `Backup creado (${filename}), pero fallo la descarga.`
      };
    }

    const deleteResult = await this.delete(filename);
    if (!deleteResult.success) {
      return {
        success: true,
        warning: true,
        message: `Backup descargado (${filename}), pero no se pudo eliminar del servidor.`,
        data: { filename, deletedFromServer: false }
      };
    }

    return {
      success: true,
      message: `Backup descargado y eliminado del servidor (${filename})`,
      data: { filename, deletedFromServer: true }
    };
  }
};

export default backupService;
